import { inject, Injectable } from '@angular/core';
import { Action, NgxsOnInit, Selector, State, StateContext } from '@ngxs/store';
import { Observable, tap } from 'rxjs';
import { GlobalSettingStateModel } from 'src/app/models/global-settings-state.model';
import { LoadGlobalSettings } from './global-settings.actions';
import { GlobalSettings } from 'src/app/models/global-settings-dto';
import { GlobalSettingsApiService } from 'src/app/services/global-settings-api.service';

@State<GlobalSettingStateModel>({
  name: 'globalSettings',
  defaults: {
    globalSettings: {
      isSupportFormEmailRequired: false
    }
  }
})
@Injectable()
export class GlobalSettingsState implements NgxsOnInit {
  private readonly apiService = inject(GlobalSettingsApiService);

  public ngxsOnInit(ctx: StateContext<GlobalSettingStateModel>): void {
    ctx.dispatch(new LoadGlobalSettings());
  }

  @Selector()
  public static isSupportFormEmailRequired(state: GlobalSettingStateModel): boolean {
    return state.globalSettings.isSupportFormEmailRequired ?? false;
  }

  @Action(LoadGlobalSettings)
  public loadGlobalSettings(ctx: StateContext<GlobalSettingStateModel>): Observable<GlobalSettings> {
    return this.apiService.getGlobalSettings().pipe(
      tap((globaSettings: GlobalSettings) => {
        ctx.setState({ globalSettings: globaSettings });
      })
    );
  }
}
